import { depositSol } from "@solana/spl-stake-pool";
import type { Connection } from "@solana/web3.js";
import { PublicKey } from "@solana/web3.js";
import { NATIVE_SOL, toLamports } from "@stepfinance/common";
import type { Dispatch, SetStateAction } from "react";

import { confirmOptions } from "../../constants/transaction";
import type { CommonNotificationsStrings } from "../../contexts/language/languageTypes";
import type { ConnectedWallet } from "../../hooks/wallet/useConnectedWallet";
import { generateOneToOneNotificationDescription } from "../../utils/notifications";
import { sendTransaction } from "../../utils/transactions";
import { formatStringWithPlaceholders } from "../../utils/utils";

export const JITO_STAKE_POOL_ID = new PublicKey("Jito4APyf642JPZPx3hGc6WWJ8zPKtRbRs4P815Awbb");
export const JITO_SOL_MINT = new PublicKey("J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn");

export const jitoStake = async (
  wallet: ConnectedWallet,
  connection: Connection,
  amount: number,
  expectedjSOLAmount: number,
  onTransactionComplete: Dispatch<SetStateAction<boolean>>,
  notificationStrings: CommonNotificationsStrings,
) => {
  const amountToStake = toLamports(amount, 9);
  const depositInfo = await depositSol(connection, JITO_STAKE_POOL_ID, wallet.publicKey, amountToStake);

  return sendTransaction(
    connection,
    wallet,
    depositInfo.instructions,
    depositInfo.signers,
    true,
    confirmOptions,
    true,
    {
      approveMessage: notificationStrings.approveTransaction,
      inProgress: {
        message: formatStringWithPlaceholders(
          notificationStrings.youAreDoingAction.message,
          notificationStrings.youAreDoingAction.staked,
          "SOL",
        ),
        description: notificationStrings.transactionInProgress,
      },
      success: {
        message: formatStringWithPlaceholders(
          notificationStrings.youDidAction.message,
          notificationStrings.youDidAction.staked,
          "SOL",
        ),
        description: generateOneToOneNotificationDescription({
          tokenA: {
            action: notificationStrings.tokenBalanceChanges.staked,
            amount,
            mint: NATIVE_SOL,
            type: "decrease",
          },
          tokenB: {
            action: notificationStrings.tokenBalanceChanges.received,
            amount: expectedjSOLAmount,
            mint: JITO_SOL_MINT,
            type: "increase",
          },
        }),
      },
    },
    () => onTransactionComplete(true),
  );
};
